import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

export default function ContactUs() {
  return (
    <Wrapper className="section section-center">
      <div className="content">
        <h4>
          ¡Comunícate con nosotros y comienza a disfrutar de un paseo increíble!
        </h4>
        <hr className="hr" />
        <p>
          Si tienes pensado viajar al sur de Chile, o simplemente quieres un fin
          de semana de descanso cerca del mar. Visita nuestro formulario de
          contacto o escríbenos en las redes sociales.
        </p>
        <Link to="/reserva" className="btn">
          Reserva
        </Link>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  text-align: center;
  font-weight: bold;
  p {
    margin: 2rem 0;
  }
  .content {
    max-width: 700px;
    margin: 0 auto;
  }
`
